/**
 * Whether a nav target covers the current path: the path itself, or with
 * `exact` off one of its detail routes. `/` only ever matches itself.
 */
export function matchesPath(
  path: string,
  target: string,
  exact = false
): boolean {
  return (
    path === target ||
    (!exact &&
      target !== '/' &&
      path.startsWith(target.endsWith('/') ? target : `${target}/`))
  );
}

/**
 * The one entry the current path selects: the most specific target that
 * covers it, so an agent's own entry wins over Agents. Null when none does.
 */
export function pickSelectedHref(
  path: string,
  entries: readonly { href: string; exact?: boolean }[]
): string | null {
  let selected: string | null = null;
  for (const entry of entries) {
    if (!matchesPath(path, entry.href, entry.exact)) continue;
    if (selected === null || entry.href.length > selected.length)
      selected = entry.href;
  }
  return selected;
}
